import { epochMsSchema } from '@novelaide/shared-schemas'
import { z } from 'zod'

// 管理员用户名唯一规则:3-32 位小写字母 / 数字,Gateway 与 Admin 共用。
// issue message 固定为 Gateway errorCode `invalid_username`,adminValidationHook 据此直接返回结构化错误。
export const AdminUsernameSchema = z
  .string()
  .min(3, 'invalid_username')
  .max(32, 'invalid_username')
  .regex(/^[a-z0-9]+$/, 'invalid_username')

export function isStrongAdminPassword(password: string): boolean {
  return (
    password.length >= 8 &&
    password.length <= 256 &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /\d/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  )
}

// /admin/bootstrap、/admin/login、/admin/admins 与 /admin/me 响应契约：Gateway 出站与 Admin 入站共用。
export const AdminUserSchema = z.object({
  id: z.string().min(1),
  username: z.string().min(1),
  displayName: z.string().nullable(),
  status: z.enum(['active', 'disabled']),
  lastLoginAt: epochMsSchema.nullable(),
  createdAt: epochMsSchema
})

export const AdminAccountResponseSchema = z.object({ admin: AdminUserSchema })

export const AdminAccountsResponseSchema = z.object({ admins: z.array(AdminUserSchema) })

export const AdminLoginResponseSchema = z.object({
  token: z.string().min(1),
  admin: AdminUserSchema
})

export const AdminMeResponseSchema = z.object({
  adminId: z.string().nullable(),
  username: z.string().nullable()
})

export type AdminUser = z.infer<typeof AdminUserSchema>
export type AdminAccountResponse = z.infer<typeof AdminAccountResponseSchema>
export type AdminAccountsResponse = z.infer<typeof AdminAccountsResponseSchema>
export type AdminLoginResponse = z.infer<typeof AdminLoginResponseSchema>
export type AdminMeResponse = z.infer<typeof AdminMeResponseSchema>
